<template>
    <div class="hello">
        <div class="head_box">
            <div class="head_cen" :style="windowWidth < 1441?'width: calc(100% - 40px);':'width: calc(1440px - 40px);'">
                <div class="head_text">
                    版权所有 Copyright 2025 海宁市乡厨协会监 网站备案:
                    <a class="beian_link" href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
                        浙ICP备16044215号-1
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HelloWorld",
    props: ['mainStates'],
    data() {
        return {
            windowWidth: window.innerWidth,
        };
    },
    watch: {
        windowWidth() {
            this.windowWidth = window.innerWidth;
        },
    },
    mounted() {
        const that = this
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
		window.addEventListener('resize', that.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
    }
};
</script>

<style scoped lang="less">
.hello {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .head_box {
        width: 100%;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #222629;

        .head_cen {
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;

            .head_text {
                min-height: 120px;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: center;
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 18px;
                color: #FFFFFF;
                line-height: 32px;
                text-align: center;

                .beian_link {
                    margin-left: 4px;
                    color: #FFFFFF;
                    text-decoration: none;
                }

                .beian_link:hover {
                    text-decoration: underline;
                }
            }
        }
    }
}
</style>
